import CollapsePanel from '../../../Proposal/UpdateListing/CollapsePanel/CollapsePanel'
import { Icon } from '@vzmi/shp_shared_compo'
import { Row, Col } from 'antd'
import styles from './index.css'

const BatchApplyCollapseBlock = props => {
  const {
    children
  } = props
  return (
    <CollapsePanel
      className={styles.appendBlock}
      defaultExpanded={false}
      panelHeader={(
        <Row
          type='flex'
          align='middle'
          className={styles.panelHeader}
        >
          <Col span={4}>
            <span className={styles.iconHolder}>
              <Icon
                name='compose'
                color='#e0e4e9'
                size={15}
              />
            </span>
            <strong className={styles.title}>快速套用商品詳情</strong>
          </Col>
        </Row>
      )}
    >
      {children}
    </CollapsePanel>
  )
}
export default BatchApplyCollapseBlock
